import '../scss/theme.scss'
import  '@fortawesome/fontawesome-free/css/all.css'

import ImageZoom from 'js-image-zoom'
import initBasket, { initDiscounts } from "./basket";

const checkScrollTop = () => {
    if (window.scrollY > 40 && document.body.classList.contains('top')) {
        document.body.classList.remove('top')
    }
    if (window.scrollY <= 40 && !document.body.classList.contains('top')) {
        document.body.classList.add('top')
    }
}

window.addEventListener('load', () => {
    document.getElementById('toplink').addEventListener('click', () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    })

    checkScrollTop()
    window.addEventListener('scroll', checkScrollTop)

    document.querySelectorAll('#sidebar li.has-sub a').forEach(link => {
        link.addEventListener('click', () => {
            link.parentNode.classList.toggle('shown')
        })
    })

    document.body.querySelector('#page-content').addEventListener('click', e => {
        if (e.target.classList.contains('menu-burger') || e.target.parentNode.classList.contains('menu-burger')) {
            return
        }

        if (document.body.classList.contains('sidebar-open')) {
            e.preventDefault()
            e.stopPropagation()
            document.body.classList.remove('sidebar-open')
        }
    })

    document.querySelectorAll('#sidebar-close').forEach(link => link.addEventListener('click', () => document.body.classList.remove('sidebar-open')))

    initProductButtons()
    initProductSearch()
    initZoomImage()
})

window.initZoomImage = () => {
    document.querySelectorAll('.products-wrap .categories li .img-wrap').forEach(wrap => {
        const img = wrap.querySelector('img')
        if (typeof img === 'undefined') {
            return
        }
        const options = {
            width: img.getBoundingClientRect().width,
            zoomWidth: wrap.parentNode.getBoundingClientRect().width,
            img: false,
            zoomPosition: 'bottom',
            scale: 2
        }
        return new ImageZoom(wrap, options)
    })
}

window.initDiscounts = initDiscounts

window.initProductButtons = () => {
    document.querySelectorAll('button.load-more-products').forEach(button => {
        if (!button.hasAttribute('data-initialized')) {
            button.addEventListener('click', () => {
                const listId = button.getAttribute('data-list')
                const list = document.getElementById(listId)

                if (list) {
                    const category = button.getAttribute('data-category')
                    const cntShown = parseInt(button.getAttribute('data-shown'))
                    const cntAll = parseInt(button.getAttribute('data-count'))

                    button.setAttribute('disabled', 'disabled')

                    fetch(`/wp-json/therapielaser/product/${20}/${cntShown}${category ? `/${category}` : ''}`)
                        .then(res => res.json())
                        .then(res => {
                            res.items.forEach(item => {
                                list.innerHTML += item
                            })

                            const newCnt = list.querySelectorAll('li').length

                            if (newCnt >= res.count) {
                                button.style.display = 'none';
                            } else {
                                button.setAttribute('data-shown', newCnt)
                            }

                            button.removeAttribute('disabled')

                            if (typeof initQuickBasketIcons === 'function') {
                                initQuickBasketIcons()
                            }
                            if (typeof initZoomImage === 'function') {
                                initZoomImage()
                            }
                        })
                }
            })
            button.setAttribute('data-initialized', 'true')
        }
    })
}

window.initProductSearch = () => {
    document.querySelectorAll('.products-wrap').forEach(wrap => {
        const searchArea = wrap.querySelector('.search-area')

        if (typeof searchArea !== 'undefined') {
            const categorySlug = searchArea.getAttribute('data-category')

            const form = searchArea.querySelector('form')
            const input = form.term

            const resultList = searchArea.querySelector('.categories')

            form.addEventListener('submit', e => {
                e.preventDefault()
                e.stopPropagation()

                const term = input.value.trim()

                if (term) {
                    wrap.classList.add('searching')
                    wrap.classList.remove('result')
                    wrap.classList.remove('no-result')

                    resultList.innerHTML = ''

                    let url = `/wp-json/therapielaser/product/search/${term}`
                    if (categorySlug) {
                        url += `/${categorySlug}`
                    }

                    fetch(url)
                        .then(res => res.json())
                        .then(res => {
                            if (res.count < 1) {
                                wrap.classList.remove('searching')
                                wrap.classList.add('no-result')
                                return
                            }
                            res.items.forEach(item => {
                                resultList.innerHTML += item
                            })
                            wrap.classList.remove('searching')
                            wrap.classList.add('result')

                            if (typeof initQuickBasketIcons === 'function') {
                                initQuickBasketIcons()
                            }
                        })
                        .catch(err => {
                            console.log('ERROR', err)
                        })
                } else {
                    wrap.classList.remove('searching')
                    wrap.classList.remove('result')
                }
            })
        }
    })
}

initBasket()
